module.exports = __webpack_public_path__ + "fonts/Inter-Regular.dc13111.woff2";